import { render } from "./CreateKubernetesCluster.vue?vue&type=template&id=22187602&scoped=true"
import script from "./CreateKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./CreateKubernetesCluster.vue?vue&type=script&lang=js"

import "./CreateKubernetesCluster.vue?vue&type=style&index=0&id=22187602&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22187602"]])

export default __exports__